import { take, fork, all, call, put } from 'redux-saga/effects';
import { saveAs } from 'file-saver';

import { apiTask, watchApiTask } from '../app/sagas';
import { api, nodeApi, createApi } from '../app/api';
import { success, failure, request, action } from '../app/actions';
import * as actions from './reportsActions';

export const getGroupsTask = watchApiTask(
  actions.GET_GROUPS,
  api.post,
  '/evaluation-system/getGroups.php',
);

export const getGeneralPainelFiltersTask = watchApiTask(
  actions.GET_GENERAL_PAINEL_FILTERS,
  api.post,
  '/evaluation-system/getESFilterGeneralPainel.php',
);

export const getESGradeGeneralTask = watchApiTask(
  actions.GET_ESGRADE_GENERAL,
  api.post,
  '/evaluation-system/getESGradeGeneral.php',
);

export const getESGradeByRankingStudentTask = watchApiTask(
  actions.GET_ESGRADE_BY_RANKING_STUDENT,
  api.post,
  '/evaluation-system/getESGradeByRankingStudent.php',
);

export const getESGradeByDisciplineTask = watchApiTask(
  actions.GET_ESGRADE_BY_DISCIPLINE,
  api.post,
  '/evaluation-system/getESGradeByDiscipline.php',
);

export function* watchGeneratePdfTask() {
  while (true) {
    const { payload } = yield take(actions.GENERATE_PDF);
    const { resolve, reject } = payload;
    yield put(action(request(actions.GENERATE_PDF)));
    try {
      const { data } = yield call(nodeApi.post, '/reports/capture/pdf', payload, {
        responseType: 'blob',
      });
      if (data && data instanceof Blob) {
        yield put(action(success(actions.GENERATE_PDF)));
        saveAs(data, payload.filename);
      }
      resolve && resolve();
    } catch (error) {
      yield put(action(failure(actions.GENERATE_PDF)));
      reject && reject(error);
    }
  }
}

export function* watchGenerateBatchPdfTask() {
  while (true) {
    const { payload } = yield take(actions.GENERATE_BATCH_PDF);
    const { resolve, reject } = payload;
    yield put(action(request(actions.GENERATE_BATCH_PDF)));
    try {
      const { data } = yield call(nodeApi.post, '/reports/capture/pdf/multiple', payload, {
        responseType: 'application/json',
      });
      if (data) {
        yield put(action(success(actions.GENERATE_BATCH_PDF), { payload: data }));
      }
      resolve && resolve(data);
    } catch (error) {
      yield put(action(failure(actions.GENERATE_BATCH_PDF)));
      reject && reject(error);
    }
  }
}

export const getStudentsAnswersQuestionReportTask = watchApiTask(
  actions.GET_STUDENTS_ANSWERS_QUESTION_REPORT,
  api.post,
  'evaluation-system/getStudentsAnswersQuestionReport.php',
);

export const getESGradeComparativeByDisciplineTask = watchApiTask(
  actions.GET_ES_GRADE_COMPARATIVE_BY_DISCIPLINE,
  api.post,
  'evaluation-system/getESGradeComparativeByDiscipline.php',
);

export const getESGradeComparativeGeneralTask = watchApiTask(
  actions.GET_ES_GRADE_COMPARATIVE_GENERAL,
  api.post,
  'evaluation-system/getESGradeComparativeGeneral.php',
);

export const getESQuestionsDetailsByComparativeTask = watchApiTask(
  actions.GET_ES_QUESTIONS_DETAILS_BY_COMPARATIVE,
  api.post,
  'evaluation-system/getESQuestionsDetailsByComparative.php',
);

// Root module saga
export function* sagas() {
  yield all([
    fork(getGroupsTask),
    fork(getGeneralPainelFiltersTask),
    fork(getESGradeGeneralTask),
    fork(getESGradeByRankingStudentTask),
    fork(getESGradeByDisciplineTask),
    fork(watchGeneratePdfTask),
    fork(watchGenerateBatchPdfTask),

    fork(getStudentsAnswersQuestionReportTask),
    fork(getESGradeComparativeByDisciplineTask),
    fork(getESGradeComparativeGeneralTask),
    fork(getESQuestionsDetailsByComparativeTask),
  ]);
}
